// extracted by mini-css-extract-plugin
export var brochureImage = "BrochureImage-module--brochure-image--6c7d6";